// import qs from 'qs';
import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_topicSet/Load',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_topicSet/Get',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_topicSet/Add',
      data,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_topicSet/Update',
      data,
    });
  },
  Del(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_topicSet/Delete',
      headers: { 'Content-Type': 'application/json' },
      data,
    });
  },
};
